<template>
    <el-container style="padding:0px;background:#fff;height:100%;">
        <el-main style="padding:0px;background:#fff;height:100%;">
            <router-view></router-view>
        </el-main>
    </el-container>
</template>

<script>
export default {
    name: 'wechatMain',
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
</style>



// WEBPACK FOOTER //
// src/views/wechat/main.vue